// components/ProfMessage.tsx — ported from docs/superpowers/design-2026-04-21/messages.jsx

import type { JSX, ReactNode } from 'react';
import { useTokens } from '../state/theme';
import { ProfAvatar } from './ProfAvatar';

export type ProfMessageTone = 'right' | 'wrong';

export interface ProfMessageProps {
  children: ReactNode;
  tone?: ProfMessageTone;
  toneLabel?: string;
  showHeader?: boolean;
  compact?: boolean;
}

export function ProfMessage({
  children,
  tone,
  toneLabel,
  showHeader = true,
  compact = false,
}: ProfMessageProps): JSX.Element {
  const tokens = useTokens();
  const toneColor = tone === 'right' ? tokens.right : tone === 'wrong' ? tokens.wrong : null;
  const toneBg    = tone === 'right' ? tokens.rightSoft : tone === 'wrong' ? tokens.wrongSoft : null;
  const label     = toneLabel || (tone === 'right' ? 'Giusto' : tone === 'wrong' ? 'Ripassiamo' : null);
  return (
    <div className="asc-fade-in" style={{ display: 'flex', gap: 10, alignItems: 'flex-start',
      marginTop: compact ? 6 : 14 }}>
      {showHeader ? <ProfAvatar/> : <div style={{ width: 28, flexShrink: 0 }}/>}
      <div style={{ flex: 1, minWidth: 0 }}>
        {showHeader && (
          <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 6 }}>
            <span style={{
              fontFamily: tokens.fonts.body, fontSize: 12.5, fontWeight: 600,
              color: tokens.text, letterSpacing: -0.05,
            }}>Il Prof</span>
            {label && toneColor && (
              <span style={{
                display: 'inline-flex', alignItems: 'center', gap: 5,
                padding: '2px 8px 2px 7px', borderRadius: tokens.radius.pill,
                background: toneBg ?? undefined, color: toneColor,
                fontFamily: tokens.fonts.body, fontSize: 10.5, fontWeight: 600, letterSpacing: 0.3,
              }}>
                <span style={{ width: 5, height: 5, borderRadius: '50%', background: toneColor }}/>
                {label}
              </span>
            )}
          </div>
        )}
        <div style={{ color: tokens.text }}>{children}</div>
      </div>
    </div>
  );
}
